import { render } from "./PreviewTab.vue?vue&type=template&id=39bb6790&scoped=true"
import script from "./PreviewTab.vue?vue&type=script&lang=js"
export * from "./PreviewTab.vue?vue&type=script&lang=js"

import "./PreviewTab.vue?vue&type=style&index=0&id=39bb6790&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bb6790"]])

export default __exports__